import Workspace from './Workspace';
export { default as WorkspacePage } from './WorkspacePage';
export default Workspace;
